export default __webpack_public_path__ + "static/media/cp-userInfo.2ca4135b.png";